import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { Blog } from '../sections/Blog';
import { Brand } from '../sections/Brand';
import { Testimonial } from '../sections/Testimonial';
import { GetTouch } from '../sections/GetTouch';
import { Link } from 'react-router-dom';
import AboutTeam from '../sections/AboutTeam';

export const About = () => {

  const innovationCard = [
    {
      image: '/assets/images/card-img-1.svg',
      title: 'Innovation-Driven ',
      description: 'We think ahead, explore new ideas, and turn creativity into real solutions that help businesses grow and stay competitive globally. '
    },
    {
      image: '/assets/images/card-img-2.svg',
      title: 'Transparent Approach ',
      description: 'We keep things open and honest—clear communication, shared goals, and full visibility from project start to final delivery. '
    },
    {
      image: '/assets/images/card-img-3.svg',
      title: 'Accessible Technology ',
      description: 'We build user-friendly, scalable tech solutions that are easy to use, cost-effective, and ready for businesses of all sizes. '
    },
    {
      image: '/assets/images/card-img-4.svg',
      title: 'Collaborative Teamwork ',
      description: 'We work together as one—sharing knowledge, supporting each other, and combining our strengths to deliver smarter, faster results. '
    }
  ]

  return (

    <>
    {/* About Banner */}
    <div className='about-page'>
      <div className='about-bg'>
        <div className='about-shap-1 con-shap-c'>
          <img src="../assets/images/whi-5.svg" alt="" />
        </div>
        
        <div className='about-shap-3'>
          <img src="../assets/images/about-shap-1.png" alt="" />
        </div>
        <div className='about-shap-4'>
          <img src="../assets/images/about-shap-2.png" alt="" />
        </div>
        <div className='about-shap-5 con-shap-c'>
          <img src="../assets/images/about-shap-3.svg" alt="" />
        </div>
        
        <Container>
          <Row className='align-items-center'>
            <div className='col-lg-5 d-lg-block d-none position-relative' data-aos="fade-right" data-aos-duration="2000">
              <div className='about-area-img text-center'>
                <img src="../assets/images/about-area-img.png" alt="" />
              </div>

              <div className='about-shap-2'>
                <img src="../assets/images/whi-2.svg" alt="" />
              </div>

              <div className='about-shap-6'>
                <img src="../assets/images/whi-3.svg" alt="" />
              </div>

            </div>
            <div className='col-xl-7 col-lg-7 padding-0' data-aos="fade-left" data-aos-duration="2000">
              <div className='tech-content text-max-width'>
                <h2 className='max-title'>We Provide Perfect It Solutions & <span className='imuii-color'>Technology</span> For Any Startups.</h2>
                <p>We use a prioritising structure, realistic simulations, and the combined knowledge of our interdisciplinary teams to offer exceptional digital experiences.</p>
                <Link to='/contact'>
                  <button className='get-btn get-margin'>Get Started</button>
                </Link>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </div>

    {/* About About Section */}
    <section className='about-area-padding'>
      <Container>
        <Row className='align-items-center'>
          <div className="col-lg-6 margin-about" data-aos="fade-right" data-aos-duration="2000">
            <div className='position-relative'>
              <div className='our-shap-1'>
                <img src="../assets/images/our-shap-1.svg" alt="" />
              </div>

              <div className='our-shap-8'>
                <img src="../assets/images/our-shap-8.png" alt="" />
              </div>
              <div className='ifive-img'>
                <img src="../assets/images/ifive-img.svg" alt="" />
              </div>
              <div className='our-shap-4'>
                <img src="../assets/images/our-shap-4.png" alt="" />
              </div>
              <div className='our-shap-5'>
                <img src="../assets/images/our-shap-5.jpg" alt="" />
              </div>
              <div className='our-shap-6'>
                <img src="../assets/images/our-shap-6.jpg" alt="" />
              </div>
              <div className='our-shap-2'>
                <img src="../assets/images/our-shap-2.svg" alt="" />
              </div>
              <div className='our-shap-3'>
                <img src="../assets/images/our-shap-3.svg" alt="" />
              </div>
              <div className='our-shap-7'>
                <img src="../assets/images/our-shap-7.svg" alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-6" data-aos="fade-left" data-aos-duration="2000">
            <div className='about-area'>
              <div className='about-content'>
                <h5>OUR ROOTS</h5>
                <h3>We Are Growing Business Success with Technology</h3>
                <p>We mix future thinking with simple and strong way of working. We focus on doing the work right, turning ideas into real actions, and always delivering with best quality.</p>

                <p>We’ve evolved with technology—but our core remains unchanged: integrity, creativity, and commitment to delivering impact through code, design, and collaboration. With every project, we aim not just to meet expectations, but to redefine what’s possible. </p>

                <Link to='/contact'>
                  <button className='collaborate-btn'>Let’s Collaborate</button>
                </Link>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </section>

    {/* Calture Section */}
    <section className='calture_section'>
      <Container>
        <Row className='align-items-center'>
          <div className="col-lg-6" data-aos="fade-right" data-aos-duration="2000">
            <div className='calture-content'>
              <h3>Our Culture </h3>
              <p>At IMUII, culture means more than just work—it’s how we think, build, and grow together. We believe in open minds, curious hearts, and bold action. Innovation drives us, collaboration shapes us, and passion unites us. We support each other, celebrate every small win, and learn from every challenge. Our people-first approach ensures that everyone feels valued, heard, and inspired to do their best work—every single day, no matter what. </p>

              <p>We create an environment where fresh ideas are welcome and honest conversations matter. Everyone has a voice, and every idea has potential. Our team grows not only in skills but in trust, confidence, and courage. This spirit fuels our creativity, our progress, and our pride in what we build together at IMUII. </p>
            </div>
          </div>
          <div className="col-lg-6" data-aos="fade-left" data-aos-duration="2000">
            <div className='calture-img text-center'>
              <img src="../assets/images/calture-img.jpg" alt="" />
            </div>
          </div>
        </Row>
      </Container>
    </section>

    {/* Our Mission Section */}
    <section className='mission-section'>
      <Container>
        <Row>
          <div className="col-md-6 " data-aos="fade-right" data-aos-duration="2000">
            <div className='mission-text'>
              <h3>Our Mission </h3>
              <p>To deliver innovative and reliable technology solutions that solve real business problems. We aim to empower companies to grow through purpose-driven digital tools, custom strategies, and long-term partnerships. Our mission is to stay curious, adapt fast, and build tech that makes life simpler, smarter, and more efficient for everyone—from startups to global enterprises. </p>
            </div>
          </div> 
          <div className="col-md-6" data-aos="fade-left" data-aos-duration="2000">
            <div className='mission-text'>
              <h3>Our Vision</h3>
              <p>To become a global technology leader known for transforming ideas into impactful digital experiences. We envision a future where businesses trust us to guide their digital growth with creativity, precision, and care. Through continuous learning and bold innovation, we strive to shape the tech of tomorrow—making it accessible, meaningful, and beneficial to all. </p>
            </div>
          </div>
          <div className="col-lg-12" data-aos="zoom-in" data-aos-duration="2000">
            <div className='mission-img'>
              <img src="../assets/images/mission-img.jpg" alt="" />
            </div>
          </div>
        </Row>
      </Container>
    </section>

    {/* Team Section */}
    <AboutTeam />

    {/* Get Touch Section */}
    <GetTouch />

    {/* About Card Section */}
    <section className='about-card-section'>
      <Container>
        <Row>
          {
            innovationCard.map((innovationData,index)=>(
              <div className='col-lg-3 col-sm-6 mb-lg-0 mb-20' data-aos="fade-up-right" data-aos-duration="2000" key={index}>
                <div className='innovation-card'>
                  <div className='about-card-img'>
                    <img src={innovationData.image} alt="" />
                  </div>
                  <h3 >{innovationData.title}</h3>
                  <p>{innovationData.description}</p>
                </div>
              </div>
            ))
          }
        </Row>
      </Container>
    </section>

    {/* Our Blog */}
    <Blog />

    {/* Brand Section */}
    <Brand />

    {/* Testimonial Section */}
    <Testimonial />

    </>
  )
}
